import { Typography, Button } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import theme from "../styles";

const useStyles = makeStyles(
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-evenly",
      padding: theme.spacing(5),
      paddingTop: theme.spacing(12),
    },
    cardTitle: {
      color: theme.palette.primary.main,
      padding: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
    },
    cardDescription: {
      padding: theme.spacing(5),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
    },
    button: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(5),
      padding: "1.5em",
      whiteSpace: "nowrap",
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(1),
      },
    },
  })
);

export default function PageWelcomeCard() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <span className={classes.root}>
      <div>
        <Typography className={classes.cardTitle} variant="h2">
          404 - Page Not Found
        </Typography>
      </div>
      <div className={classes.cardDescription}>
        <Typography variant="h5">
          Sorry, we can't find the page you were looking for. Unless you just
          wanted to see our 404 page?
        </Typography>
      </div>
      <Button
        variant="contained"
        size="large"
        className={classes.button}
        startIcon={<ArrowBack />}
        onClick={() => history.push("/")}
      >
        Take me back!
      </Button>
    </span>
  );
}
